import { fromPairs } from 'lodash';
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { LooseRecord } from '../../types/common';

export default function useQueryParams(): LooseRecord<string, string> {
  const [searchParams] = useSearchParams();
  return useMemo(() => fromPairs([...searchParams.entries()]), [searchParams]);
}
